import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import error from "./errors/errors";
import session from "./session/session";
import users from "./userReducer";
import connections from "./connectionReducer";
import tags from "./tagReducer";
import content from "./contentReducer";
import ui from "./uiReducer"

export default combineReducers({
  session,
  error,
  users,
  connections,
  tags,
  ui,
  content,
  form: formReducer
});


